import { faClock } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import queryString from 'query-string';
import React from 'react';
import { useLocation } from 'react-router-dom';
import { Card, CardBody } from 'reactstrap';

import { AutoFocusHeader } from '../_components/auto-focus-header';
import { StartOverButton } from '../_components/start-over-button';

export function SessionExpired() {
  const location = useLocation();
  const { search } = location;
  const { invalidUrl } = queryString.parse(search);

  const message = invalidUrl ? (
    <>
      <p className="text-large mt-5">
        The secured URL is invalid. There are two likely causes:
      </p>
      <ul className="text-start">
        <li>this secured URL has expired</li>
        <li>the URL was pasted or typed incorrectly</li>
      </ul>
    </>
  ) : (
    <p className="text-large mt-5">Your session has expired.</p>
  );
  return (
    <div className="mx-auto col-sm-6 col-md-5 col-lg-4 col-xl-3 my-2">
      <Card className="shadow-sm py-3">
        <CardBody>
          <div className="text-center">
            <AutoFocusHeader id="main-content">Session expired</AutoFocusHeader>
            {message}
            <p className="text-large mt-5">
              Please request an email to receive a new secured URL.
            </p>
            <p className="my-5">
              <FontAwesomeIcon
                icon={faClock}
                color="#00a91c"
                size="8x"
                className="d-inline-block"
              />
            </p>
            <div>
              <StartOverButton label="Request Secured URL" />
            </div>
          </div>
        </CardBody>
      </Card>
    </div>
  );
}
